module.exports = __webpack_public_path__ + "img/Movies-low.47dc3cde.jpg";